import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { Grid, Segment, Icon, Table, Popup, Label, Divider } from 'semantic-ui-react';

import DyzioInstagramEmbed from '../../components/dyzio-instagram-embed2';
import { Compliance } from '../../utils/compliance';

const sf = num => {
  if (num) return (num > 1000 ? numeral(num).format('0.0a') : num);
  return '-';
};
const NUM_COLUMNS = 4;
const INSTAGRAM_POST_URL = 'https://www.instagram.com/p';
const orangeColor = { color: 'orange' };
const smallMargin = { marginTop: 3 };

const REACH_FACTOR = 11;
const IMPRESSION_FACTOR = 12.3;

const ProfileLatestInstagrams = props => {
  const instagramPosts = props.instagrams.data;
  const adPosts = _.filter(instagramPosts, p => Compliance.isAsaCompliant(p.caption));

  const adPercentage = Math.round((adPosts.length / instagramPosts.length) * 100);

  const chunks = _.chunk(instagramPosts, NUM_COLUMNS);
  const dataCollectedDate = moment();

  const followerCount = props.influencer.instagramCount;

  console.log('INSTAGRAM USER', followerCount);
  return (
    <Segment padded color="pink">
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <h3>
              <Icon name="instagram" color="pink" /> Latest Instagram posts&nbsp;
              <span style={{ color: 'grey' }}>(data collected {dataCollectedDate.fromNow()})</span>
              <div style={{ float: 'right' }}><Label color="pink">{adPercentage}% #AD</Label></div>
            </h3>
            <Divider />
          </Grid.Column>
        </Grid.Row>
        { _.map(chunks, (chunk => <Grid.Row columns={NUM_COLUMNS}>
          { _.map(chunk, (post => {
            const engagements = (post.totalLikes || 0) + (post.comments || 0);
            const engagementRate = (engagements / followerCount) * 100;
            const isAd = Compliance.isAsaCompliant(post.caption);

            const estimatedReach = Math.round(engagements * REACH_FACTOR);
            const estimatedImpressions = Math.round(engagements * IMPRESSION_FACTOR);

            const isHiddenLikes = post.totalLikes === -1;

            return (<Grid.Column key={post.code}>
              <a
                title="open on Instagram"
                target="_blank"
                rel="noopener noreferrer"
                href={`${INSTAGRAM_POST_URL}/${post.code}`}
              >
                <DyzioInstagramEmbed
                  assetId={post.code}
                  useInstagramStyle
                  imageUrl={post.corsImageUrl}
                />
              </a>
              <Table singleLine style={smallMargin}>
                <Table.Row>
                  <Table.Cell>
                    <Icon name="like outline" /> { isHiddenLikes ? 'hidden' : sf(post.totalLikes) }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="comments outline" /> { sf(post.comments) }
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name="eye" /> { sf(post.views) }
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan="2">
                    <Icon name="percent" color="pink" />
                    { isHiddenLikes ? 'hidden likes' : `${numeral(engagementRate).format('0.00')} ENG. RATE` }
                  </Table.Cell>
                  <Table.Cell style={{ textAlign: 'center' }}>
                    <strong>{ isAd ? <Label color="pink">#AD</Label> : <Label>ORGANIC</Label>}</strong>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell colSpan="3">

                    <Popup
                      content={_.join(post.mentions, ', ')}
                      trigger={
                        <span>
                          <Icon name="at" color="pink" />
                          { _.map(_.take(post.mentions, 2), m => (<Label>{_.toLower(m)}</Label>)) }
                        </span>
                      }
                    />
                  </Table.Cell>
                </Table.Row>
                {
                  false && (post.likes !== post.totalLikes) &&
                  <Table.Row>
                    <Table.Cell style={orangeColor} colSpan="3">
                      <Popup
                        content="Total likes - Organic + Paid"
                        trigger={
                          <span><Icon name="like outline" /> { sf(post.totalLikes) } TOTAL LIKES</span>
                        }
                      />
                    </Table.Cell>
                  </Table.Row>
                }

                <Table.Row>
                  <Table.Cell colSpan="3">
                    <Popup
                      content="Estimated Reach & Impressions"
                      trigger={
                        <span>
                          <Icon name="eye" color="blue" />
                          <Label basic>&nbsp;{ sf(estimatedReach) } REACH</Label>
                          <Label basic>&nbsp;{ sf(estimatedImpressions) } IMPS</Label>
                        </span>
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              </Table>
            </Grid.Column>);
          }

          )) }
        </Grid.Row>))
        }
      </Grid>
    </Segment>
  );
};


ProfileLatestInstagrams.propTypes = {
  instagrams: PropTypes.array.isRequired,
};

export default ProfileLatestInstagrams;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-latest/profile-latest-instagrams.js
 **/